var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-0 my-sm-4" },
    [
      _c(
        "v-container",
        {
          staticClass: "main-header py-0 px-0",
          class: { isCheckout: _vm.isCheckout }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "" } },
            [
              !_vm.isCheckout
                ? _c(
                    "v-btn",
                    {
                      staticClass: "mr-2 hamburger-menu",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.menu = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-menu")])],
                    1
                  )
                : _vm._e(),
              _c(
                "router-link",
                { staticClass: "main-link", attrs: { to: "/" } },
                [
                  _vm.$vuetify.breakpoint.smAndUp && !_vm.isCheckout
                    ? _c("img", {
                        staticClass: "custom-logo",
                        class: { isCheckout: _vm.isCheckout },
                        attrs: {
                          src: require("@/assets/" + _vm.$t("homepage.logo")),
                          itemprop: "logo"
                        }
                      })
                    : _c("img", {
                        staticClass: "mobile-custom-logo",
                        attrs: {
                          src: require("@/assets/" + _vm.$t("homepage.logo"))
                        }
                      })
                ]
              ),
              _c("v-spacer", { staticClass: "divider" }, [
                !_vm.isCheckout ? _c("div", [_vm._v("|")]) : _vm._e()
              ]),
              !_vm.isCheckout
                ? _c(
                    "div",
                    { staticClass: "main-menu" },
                    _vm._l(_vm.allCategories, function(category, index) {
                      return _c(
                        "v-btn",
                        {
                          key: index,
                          class: { "ml-1": index > 0, "#4a030d": true },
                          attrs: { text: "", to: "/category/" + category.alias }
                        },
                        [_vm._v(_vm._s(category.name))]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "mr-1",
                                  attrs: { color: "#4a030d", text: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(" " + _vm._s(_vm.activeLocale) + " ")]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.locales, function(item, index) {
                      return _c(
                        "v-list-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.changeLocale(item)
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-title",
                            {
                              staticClass: "text-uppercase",
                              staticStyle: { color: "#4a030d" }
                            },
                            [_vm._v(_vm._s(item))]
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              !_vm.isCheckout
                ? _c("v-spacer", { staticClass: "divider" }, [
                    _c("div", [_vm._v("|")])
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "shopping-cart text-center",
                  class: { isCheckout: _vm.isCheckout }
                },
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        content: _vm.itemsInCart,
                        value: _vm.itemsInCart,
                        "text-color": "white",
                        overlap: "",
                        "offset-y": _vm.$vuetify.breakpoint.xsOnly ? 20 : 0,
                        "offset-x": _vm.$vuetify.breakpoint.xsOnly ? 20 : 0
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function($event) {
                              _vm.drawer = true
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "cart-image",
                            attrs: {
                              src: require("../../assets/shoping_bag.svg")
                            }
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.$vuetify.breakpoint.smAndUp
                    ? _c("div", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("homepage.shoppingCart")) + " "
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          attrs: { temporary: "", right: true, fixed: "", width: "340" },
          model: {
            value: _vm.drawer,
            callback: function($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer"
          }
        },
        [
          _c("cart-overlay", {
            on: {
              drawerClose: function($event) {
                _vm.drawer = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          attrs: { temporary: "", absolute: "", fixed: "", width: "340" },
          model: {
            value: _vm.menu,
            callback: function($$v) {
              _vm.menu = $$v
            },
            expression: "menu"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", flat: "" } },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-uppercase font-weight-bold" },
                [_vm._v(_vm._s(_vm.$t("homepage.menuTitle")))]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      _vm.menu = false
                    }
                  }
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-list",
            _vm._l(_vm.allCategories, function(category, index) {
              return _c(
                "v-list-item",
                { key: index, attrs: { to: "/category/" + category.alias } },
                [
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v(_vm._s(category.name))])],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }